<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <div class="dashboard">
        <!-- header -->
        <header class="welcome-text mb-3">
          All Items
          <span class="welcome-name ml-2"></span>
        </header>

        <!-- main Card -->
        <div class="middle-container">
          <div
            class="box"
            @click="
              createUser = true;
              manageUser = false;
            "
          >
            <div class="card-icon">
              <i class="fa fa-use fa-2x mb-2">
                P
                <i
                  class="fas fa-plus ml-n"
                  style="font-size:20px; margin-top:-3px!important; position:absolute"
                ></i>
              </i>
              <div class="transaction-title">Create New</div>
            </div>
          </div>
          <div
            class="box"
            @click="
              createUser = false;
              manageUser = true;
            "
          >
            <div class="card-icon">
              <i class="fa fa-2x mb-2">
                <i
                  class="fas fa-ellipsis-v"
                  style="font-size:20px; margin-top: 7px!important; margin-left:-10px; position:absolute"
                ></i>
                Ps
              </i>
              <div class="transaction-title">View Existing</div>
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div class="account-container mt-5">
          <!-- Create Gl Tab start -->
          <b-tabs pills :active-nav-item-class="current" v-if="createUser">
            <!-- Gl Tab -->
            <b-tab title-link-class title="Create Product">
              <!-- <div class="line mb-3 mt-2"></div> -->
              <div class="mt-5">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(createProduct)">
                    <div class="containe tab-con">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="row">
                            <!-- Firstname -->
                            <div class="col-md-6 mb-3">
                              <ValidationProvider
                                name="name"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="v">
                                  Name
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="name"
                                    class="form-control"
                                    placeholder
                                    name="name"
                                  />
                                </div>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>

                            <!-- Ledger -->
                            <div class="div3i col-md-6 mb-3">
                              <ValidationProvider
                                name="category"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <div class>
                                  <label for="category">
                                    Ledger Category
                                    <span class="text-danger">*</span>
                                  </label>
                                  <b-form-select
                                    v-model="ledger"
                                    :options="options"
                                    class
                                  ></b-form-select>
                                </div>

                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                          </div>

                          <!-- Product Code -->
                          <div class="row">
                            <div class="form-group col-md-6 col-sm-12">
                              <ValidationProvider
                                name="type"
                                rules="required|min:3|max:3"
                                v-slot="{ errors }"
                              >
                                <label for="code">Code</label>
                                <input
                                  type="text"
                                  id="code"
                                  v-model="code"
                                  class="form-control"
                                  placeholder="e.g 001"
                                  minlength="3"
                                  maxlength="3"
                                  name="name"
                                />
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                            <!-- Fee -->
                            <div class="form-group col-md-6 col-sm-12">
                              <ValidationProvider
                                name="fee"
                                id="fee"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="fee">Fee</label>
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <div
                                      class="input-group-text"
                                      style="background:gainsboro"
                                    >
                                      &#8358;
                                    </div>
                                  </div>
                                  <input
                                    type="number"
                                    v-model="fee"
                                    class="form-control"
                                    placeholder="0.00"
                                    name="fee"
                                  />
                                </div>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>
                          </div>

                          <!-- Minimum Balance -->
                          <div class="row">
                            <div class="col-md-6 col-sm-12">
                              <ValidationProvider
                                name="minBalance"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <label for="glType">Minimum Balance</label>
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <div
                                      class="input-group-text"
                                      style="background:gainsboro"
                                    >
                                      &#8358;
                                    </div>
                                  </div>
                                  <input
                                    type="number"
                                    v-model="minBalance"
                                    class="form-control"
                                    placeholder="0.00"
                                    name="minBalance"
                                  />
                                </div>
                                <span style="font-size:13px; color:red">
                                  <span v-if="errors[0]">
                                    <i class="fas fa-ban"></i>
                                  </span>
                                  {{ errors[0] }}
                                </span>
                              </ValidationProvider>
                            </div>

                            <div class="col-md-6 mt-3 mt-sm-0">
                              <div class="row">
                                <!-- Interest -->
                                <div class="col-md-6 col-sm-12">
                                  <ValidationProvider
                                    name="interest"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <label for="interest">Interest</label>
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <div
                                          class="input-group-text"
                                          style="background:gainsboro"
                                        >
                                          &#8358;
                                        </div>
                                      </div>
                                      <input
                                        type="number"
                                        v-model="rate"
                                        class="form-control"
                                        placeholder="0.00"
                                        name="interest"
                                      />
                                    </div>
                                    <span style="font-size:13px; color:red">
                                      <span v-if="errors[0]">
                                        <i class="fas fa-ban"></i>
                                      </span>
                                      {{ errors[0] }}
                                    </span>
                                  </ValidationProvider>
                                </div>

                                <!-- Rate -->
                                <div class="col-md-6 col-sm-12 mt-3 mt-sm-0">
                                  <ValidationProvider
                                    name="interest"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <label for="glType">Cycle</label>
                                    <select
                                      name="type"
                                      class="form-control"
                                      v-model="cycle"
                                      id
                                    >
                                      <option value>--Select--</option>
                                      <option value="daily">Daily</option>
                                      <option value="weekly">Weekly</option>
                                      <option value="monthly">Monthly</option>
                                      <option value="yearly">Yearly</option>
                                    </select>
                                    <span style="font-size:13px; color:red">
                                      <span v-if="errors[0]">
                                        <i class="fas fa-ban"></i>
                                      </span>
                                      {{ errors[0] }}
                                    </span>
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="submit-btn">
                          <b-button
                            type="submit"
                            class="btn mt-3 text-center ml-3 btn-primary"
                            >Create</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-tab>
          </b-tabs>
          <!-- Create Gl tab end -->

          <!-- Manage Gl Tab start -->

          <b-tabs
            pills
            no-body
            :active-nav-item-class="current"
            v-if="manageUser"
          >
            <!-- Gl Tab -->
            <b-tab title="Existing Products">
              <div class="line mb-3 mt-2"></div>
              <div class="tab-c">
                <div class="mb-0">
                  <div class="col-12">
                    <div class="top mb-2">
                      <div class="mb-3">Products</div>
                      <div>
                        <div class="input-group float-right">
                          <input
                            type="search"
                            placeholder="Search GL"
                            class="form-control"
                          />
                          <div class="input-group-append">
                            <div class="input-group-text">
                              <i class="fa fa-search"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="recent-transactions table-responsive">
                      <table>
                        <tr style="color:#333" class>
                          <th>Name</th>
                          <th>Code</th>
                          <th>Minimum Balance</th>
                          <th>Fee</th>
                          <th>Interest rate</th>
                          <th>Date Created</th>
                          <th>Action</th>
                        </tr>

                        <tr v-for="(product, index) in Products" :key="index">
                          <td>{{ product.name }}</td>
                          <td>{{ product.code }}</td>
                          <td>{{ product.minBalance }}</td>
                          <td>&#8358; {{ product.fee }}</td>
                          <td>{{ product.interest.rate }}%</td>
                          <td>{{ product.createdAt }}</td>
                          <td
                            class="view"
                            @click="
                              Details(index);
                              details = true;
                            "
                          >
                            View
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
          <!-- Manage User Tab end -->

          <!-- Product Details modal -->
          <b-modal hide-footer v-model="details" hide-header-close>
            <template v-slot:modal-title>Product Details</template>
            <div class="modal-container">
              <form action @submit.prevent="updateProduct">
                <div class="row">
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Name</label>
                    <div>
                      <input
                        type="text"
                        v-model="Name"
                        class="form-control"
                        placeholder="0.00"
                        name="fee"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Code</label>
                    <div>
                      <input
                        type="text"
                        v-model="Code"
                        minlength="3"
                        disabled
                        required
                        maxlength="3"
                        class="form-control"
                        placeholder="001"
                        name="Code"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Minimum Balance</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div
                          class="input-group-text"
                          style="background:gainsboro"
                        >
                          &#8358;
                        </div>
                      </div>
                      <input
                        type="number"
                        v-model="MinBalance"
                        required
                        class="form-control"
                        placeholder="0.00"
                        name="fee"
                      />
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Fee</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div
                          class="input-group-text"
                          style="background:gainsboro"
                        >
                          &#8358;
                        </div>
                      </div>
                      <input
                        type="number"
                        v-model="Fee"
                        class="form-control"
                        placeholder="0.00"
                        name="fee"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Interest Rate</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div
                          class="input-group-text"
                          style="background:gainsboro"
                        >
                          %
                        </div>
                      </div>
                      <input
                        type="number"
                        v-model="Rate"
                        required
                        class="form-control"
                        placeholder="0.00"
                        name="fee"
                      />
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Cycle</label>
                    <div>
                      <select
                        name="type"
                        class="form-control"
                        v-model="Cycle"
                        id
                      >
                        <option value>--Select--</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="yearly">Yearly</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="fee">Ledger</label>
                    <div class="input-group">
                      <b-form-select v-model="Ledger" :options="options" class></b-form-select>
                    </div>
                  </div>
                </div> -->
                <div class="text-danger">
                  **Please note that changes to interest and fees will take effect
                  from the next cycle
                </div>

                <div class="d-flex justify-content-between">
                  <div
                    role="button"
                    class="btn btn-primary px-4 mt-4"
                    @click="cancel"
                  >
                    Cancel
                  </div>
                  <button class="btn btn-primary px-4 mt-4" type="submit">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </b-modal>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "../../../utils/vue-loader/loader.vue";
import { ledgerService } from "../../../services/AdminServices/Ledger.services";
import { productService } from "../../../services/AdminServices/Product.services";

export default {
  name: "Products",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader
  },
  data() {
    return {
      createUser: true,
      manageUser: false,
      details: false,
      loading: false,
      name: "",
      code: "",
      minBalance: "",
      fee: "",
      rate: "",
      cycle: "",
      ledger: "",
      Ledgers: [],
      Products: [],
      ProductDetails: {},
      options: [],
      category: null,
      optionsApi: []
    };
  },
  computed: {
    current() {
      return "current";
    },
    Name: {
      get() {
        return this.ProductDetails.name;
      },
      set(value) {
        return (this.ProductDetails.name = value);
      }
    },
    MinBalance: {
      get() {
        return this.ProductDetails.minBalance;
      },
      set(value) {
        return (this.ProductDetails.minBalance = value);
      }
    },
    Ledger: {
      get() {
        return this.ProductDetails.ledger;
      },
      set(value) {
        return (this.ProductDetails.ledger = value);
      }
    },
    Code: {
      get() {
        return this.ProductDetails.code;
      },
      set(value) {
        return (this.ProductDetails.code = value);
      }
    },
    Fee: {
      get() {
        return this.ProductDetails.fee;
      },
      set(value) {
        return (this.ProductDetails.fee = value);
      }
    },
    Rate: {
      get() {
        if (this.ProductDetails.interest)
          return this.ProductDetails.interest.rate;
        return this.ProductDetails.interest;
      },
      set(value) {
        if (this.ProductDetails.interest)
          return (this.ProductDetails.interest.rate = value);
        return (this.ProductDetails.interest = value);
      }
    },
    Cycle: {
      get() {
        if (this.ProductDetails.interest)
          return this.ProductDetails.interest.cycle;
        return this.ProductDetails.interest;
      },
      set(value) {
        if (this.ProductDetails.interest)
          return (this.ProductDetails.interest.cycle = value);
        return (this.ProductDetails.interest = value);
      }
    }
  },
  methods: {
    transfer() {
      this.$store.dispatch("transfer");
    },
    account() {
      this.$store.dispatch("account");
    },
    utility() {
      this.$store.dispatch("utility");
    },
    formatAmount(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //this function automatically adds commas to the value where necessary
    },

    //Get Gl categories
    getLedgers() {
      ledgerService
        .GetLedgers()
        .then(res => {
          this.optionsApi = res;
          let options = this.options;
          this.optionsApi.unshift({
            _id: "",
            name: "Select Category"
          });
          this.optionsApi.forEach(item => {
            options.push({
              value: item._id,
              text: item.name
            });
          });
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //Create Product
    createProduct() {
      this.loading = true;
      let data = {
        name: this.name,
        code: this.code,
        minBalance: this.minBalance,
        ledger: this.ledger,
        fee: this.fee,
        rate: this.rate,
        cycle: this.cycle
      };
      productService
        .CreateProduct(data)
        .then(res => {
          this.$toastr.s(res.message, "Successful");
          (this.createUser = false), (this.manageUser = true);
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //get products
    getProducts() {
      productService
        .GetProducts()
        .then(res => {
          this.Products = res;
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    Details(n) {
      let product = this.Products[n];
      this.ProductDetails = product;
    },

    cancel() {
      this.details = false;
      this.getProducts();
    },

    //Update product
    updateProduct() {
      this.loading = true;
      let data = {
        id: this.ProductDetails._id,
        name: this.Name,
        code: this.Code,
        minBalance: this.MinBalance,
        ledger: this.Ledger,
        fee: this.Fee,
        rate: this.Rate,
        cycle: this.Cycle
      };
      productService
        .UpdateProduct(data)
        .then(res => {
          this.details = false;
          this.$toastr.s(res.message, "Successful");
          (this.createUser = false), (this.manageUser = true);
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeExceeded() {
      return;
    }
  },
  mounted() {
    this.$store.dispatch("misc3");
    //this.getLedgers();
    //this.getProducts();
  }
};
</script>

<style scoped lang="scss">
.box-2 {
  padding: 24px 20px !important;
}
.box-3 {
  padding: 23px 20px !important;
}
.box-4,
.box-5 {
  padding: 25px 20px !important;
}
.box {
  cursor: pointer;
}
.link {
  text-decoration: none;
}
.middle-container {
  font-family: $SourceSansPro-Light;
  margin-right: 40px;
  //justify-content: flex-start;
}
.card-icon {
  margin: 50px 35px;
  width: 100px;
  text-align: center;
  .fa {
    color: $main-color;
  }
}

.submit-btn {
  width: 100%;
  display: flex;
  justify-content: start;
}

.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
}
.current {
  background: $main-color;
}

.view {
  cursor: pointer;
  color: blue;
  &:hover {
    text-decoration: underline;
  }
}

.top {
  display: flex;
  justify-content: space-between;
}
</style>
